<template>
  <div id="page" style="display: flex; flex-direction: column; margin: auto; width: 100%">
    <Menu />

    <section id="hero-login">
      <Hero />
    </section>

    <section id="features">
      <EveryThing />
    </section>

    <section id="why-choose-us">
      <WhyTeam />
    </section>

    <section id="contact">
      <Footer />
    </section>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import router from '@/router'
import Menu from '@/components/Menu.vue'
import Hero from '@/components/Hero.vue'
import EveryThing from '@/components/EveryThing.vue'
import WhyTeam from '@/components/WhyTeam.vue'
import Footer from '@/components/Footer.vue'
import { VerifyUsers } from '@/api/accountsClient'
import { useUserStore } from '@/stores/userStore'

const tokenLoader = ref(false)
const userStore = useUserStore()

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const redirect = urlParams.get('redirect')
  const redirectdomain = urlParams.get('redirectdomain')

  if (redirect && redirectdomain) {
    try {
      tokenLoader.value = true
      const data = await VerifyUsers()
      const hasQueryParams = redirectdomain.includes('?')
      const separator = hasQueryParams ? '&' : '?'

      if (data) {
        window.location.href = `${redirectdomain}${separator}token=${userStore?.token}&role=${userStore?.role}&juid=${userStore?.juid}&redirectionDo=true`
      }

      tokenLoader.value = false
    } catch (error) {
      tokenLoader.value = false
    }
  } else if (!redirect) {
    try {
      if (userStore?.token || userStore?.token) {
        if (
          userStore?.role === 'company_user' ||
          userStore?.role === 'company_admin' ||
          userStore?.role === 'company_suadmin' ||
          userStore?.role === 'company_owner'
        ) {
          router.push('/account-admin')
        } else if (userStore.juid) {
          tokenLoader.value = true
          try {
            const data = await VerifyUsers()
            if (data) {
              tokenLoader.value = false

              router.push(`/account/${userStore.juid}`)
              tokenLoader.value = false
            }
            tokenLoader.value = false
          } catch (error) {
            tokenLoader.value = false
          }
        }
      }
    } catch (error) {
      tokenLoader.value = false
    }
  }
})
</script>

<style>
#page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
}
</style>
